import {NumberInput} from "@mantine/core";

interface NumberSelectorProps {
    min: number,
    max: number,
    value: number|undefined,
    onChange: (e: any) => void
    step?: number
    label?: string
}
const NumberSelector = ({min, max, value, step = 1, onChange, label}: NumberSelectorProps) => {
    return  <NumberInput
        label={label}
        min={min}
        max={max}
        value={value}
        onChange={onChange}
        step={step}
        w={110}
    />
}

export default NumberSelector;
